import { BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip } from 'chart.js';
import { Bar } from 'react-chartjs-2';

import { CustomerSpecificStatisticsMessage } from '../../../types/StatisticsMessage';
import { useChartTitleTranslations } from '../hooks/useChartTitleTranslations';
import { useFixedMoneyDecimals } from '../hooks/useFixedMoneyDecimals';
import { barOptions, ChartType } from '../utils/barOptions';
import { chartColors } from '../utils/chartColors';

import { ChartGrid } from './ChartGrid';
import { ChartWrapper } from './ChartWrapper';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface VesselsTabStatisticsProps {
    vesselStatistics: CustomerSpecificStatisticsMessage['vessel'];
}

export const VesselsTabStatistics = ({ vesselStatistics }: VesselsTabStatisticsProps) => {
    const chartTitles = useChartTitleTranslations();
    const vesselNames = vesselStatistics.map((vessel) => vessel.context.name);
    const backgroundColor = chartColors;

    const formatMoneyDecimals = useFixedMoneyDecimals();

    const completedOrdersData = {
        labels: vesselNames,
        datasets: [
            {
                label: ChartType.COMPLETED,
                data: vesselStatistics.map((vessel) => vessel.completedCount),
                backgroundColor,
            },
        ],
    };

    const pplData = {
        labels: vesselNames,
        datasets: [
            {
                label: ChartType.PPL,
                data: vesselStatistics.map((vessel) => formatMoneyDecimals(vessel.ppl.value)),
                backgroundColor,
            },
        ],
    };

    const totalData = {
        labels: vesselNames,
        datasets: [
            {
                label: ChartType.TOTAL,
                data: vesselStatistics.map((vessel) => vessel.total.value),
                backgroundColor,
            },
        ],
    };

    const volumeData = {
        labels: vesselNames,
        datasets: [
            {
                label: ChartType.VOLUME,
                data: vesselStatistics.map((vessel) => Math.round(vessel.volume)),
                backgroundColor,
            },
        ],
    };

    return (
        <ChartGrid>
            <ChartWrapper title={chartTitles.completedOrders}>
                <Bar data={completedOrdersData} options={barOptions} />
            </ChartWrapper>

            <ChartWrapper title={chartTitles.pricePerUnit}>
                <Bar data={pplData} options={barOptions} />
            </ChartWrapper>

            <ChartWrapper title={chartTitles.total}>
                <Bar data={totalData} options={barOptions} />
            </ChartWrapper>

            <ChartWrapper title={chartTitles.volume}>
                <Bar data={volumeData} options={barOptions} />
            </ChartWrapper>
        </ChartGrid>
    );
};
